import { Injectable, } from '@angular/core';
import { IJSScripts, AppSettingService, AppService } from '../app.service';

@Injectable({
	providedIn: 'root'
})
export class GoogleAPIService {
	constructor(
		private appSrv: AppService
	) { }

	loadScripts(): void {
		// load map
		let js: IJSScripts = {
			name: "GoogleMap",
			src: "https://maps.googleapis.com/maps/api/js?key=" + AppSettingService.appConfig.GoogleMapJSAPI + "&callback=Function.prototype&libraries=places,marker&loading=async"
		}
		this.appSrv.loadJSScript(js);

		// load chart
		js = {
			name: "GoogleChart",
			src: "https://www.gstatic.com/charts/loader.js"
		};
		return this.appSrv.loadJSScript(js);
	}

	loadGoogleDrive(): any {
		let js: IJSScripts = {
			name: "GoogleDrive",
			src: "https://apis.google.com/js/api.js"
		};
		return this.appSrv.loadJSScript(js);
	}

	loadGoogleAccount(): any {
		let js: IJSScripts = {
			name: "GoogleAccount",
			src: "https://accounts.google.com/gsi/client"
		};
		return this.appSrv.loadJSScript(js);
	}
}
